import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ErrorBoundary() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
        flexGrow: 1,
      }}
    >
      <Grid size={{ xs: 12 }}>
        <Paper
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Stack direction="column" spacing={2}>
            <Typography variant="h2" component="h2">
              {t('ui.error.page-no-found')}
            </Typography>
            <Button onClick={() => navigate(-1)} color="primary" variant="contained">
              {t('ui.error.back')}
            </Button>
          </Stack>
        </Paper>
      </Grid>
    </Box>
  );
}
